import { Vector2 } from "three";
import settings from "./settings";

const maxFrameBufferSize = new Vector2(1280, 720);
const baseSize = Math.sqrt(maxFrameBufferSize.x * maxFrameBufferSize.y);
const maxSize = baseSize * baseSize;

export const rendererSize = new Vector2();

export function getRenderBufferSize() {
  return {
    width: rendererSize.x * settings.pixelRatio,
    height: rendererSize.y * settings.pixelRatio,
  };
}

function resize(windowWidth, windowHeight) {
  let width = windowWidth;
  let height = windowHeight;
  if (windowWidth * windowHeight > maxSize) {
    const ratio = height / width;
    width = baseSize;
    height = Math.floor(baseSize * ratio);
    let newSize = width * height;
    const scalar = Math.sqrt(maxSize / newSize);
    width = Math.floor(width * scalar);
    height = Math.floor(height * scalar);
  }
  return {
    width,
    height,
  };
}

export function setRendererSize(renderer, windowWidth, windowHeight) {
  // const width = windowWidth;
  // const height = windowHeight;
  let { width, height } = resize(windowWidth, windowHeight);
  if (settings.renderBufferFullscreen) {
    width = windowWidth;
    height = windowHeight;
  }
  rendererSize.x = width;
  rendererSize.y = height;
  renderer.setSize(width, height);
  // renderer.domElement.style.width = `${width}px`;
  // renderer.domElement.style.height = `${height}px`;
  renderer.domElement.style.width = `${windowWidth}px`;
  renderer.domElement.style.height = `${windowHeight}px`;
}
